import { stringify } from "../../util/querystring-util";
import {
  CreateComponentDeploymentRequestsRequest,
  CreateComponentDeploymentRequestsResponse,
  GetDeploymentRequestsRequest,
  GetDeploymentRequestsResponse,
  UpdateComponentDeploymentRequestsRequest,
  UpdateComponentDeploymentRequestsResponse,
  UpdateComponentDeploymentRequestsStatusRequest,
  UpdateComponentDeploymentRequestsStatusResponse,
} from ".";
import { restResourceRequester } from "../rest-resource-requester";

interface DeploymentRequestsRestResource {
  getDeploymentRequests(
    request: GetDeploymentRequestsRequest,
  ): Promise<GetDeploymentRequestsResponse>;
  updateComponentDeploymentRequestsStatus(
    request: UpdateComponentDeploymentRequestsStatusRequest,
  ): Promise<UpdateComponentDeploymentRequestsStatusResponse>;
  updateComponentDeploymentRequests(
    request: UpdateComponentDeploymentRequestsRequest,
  ): Promise<UpdateComponentDeploymentRequestsResponse>;
  createComponentDeploymentRequests(
    request: CreateComponentDeploymentRequestsRequest,
  ): Promise<CreateComponentDeploymentRequestsResponse>;
}

const REST_RESOURCE_NAME = "deployment-requests";

/**
 * GET /deployment-requests
 */
const getDeploymentRequests = restResourceRequester<
  GetDeploymentRequestsRequest,
  GetDeploymentRequestsResponse
>("GET", (request) => {
  return `${REST_RESOURCE_NAME}?${stringify(request)}`;
});

/**
 * PUT /deployment-requests/component/{deploymentRequestSeq}/status
 */
const updateComponentDeploymentReqeustsStatus = restResourceRequester<
  UpdateComponentDeploymentRequestsStatusRequest,
  UpdateComponentDeploymentRequestsStatusResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}/component/status`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /deployment-requests/component/{deploymentDate}
 */
const updateComponentDeploymentRequests = restResourceRequester<
  UpdateComponentDeploymentRequestsRequest,
  UpdateComponentDeploymentRequestsResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}/component/deploymentDate`,
  (request) => JSON.stringify(request),
);

/**
 * PUT /deployment-requests/component
 */
const createComponentDeploymentRequests = restResourceRequester<
  CreateComponentDeploymentRequestsRequest,
  CreateComponentDeploymentRequestsResponse
>(
  "PUT",
  (_) => `${REST_RESOURCE_NAME}/component`,
  (request) => JSON.stringify(request),
);

export const DeploymentRequestsRestResource: DeploymentRequestsRestResource = {
  getDeploymentRequests: getDeploymentRequests,
  updateComponentDeploymentRequestsStatus:
    updateComponentDeploymentReqeustsStatus,
  updateComponentDeploymentRequests: updateComponentDeploymentRequests,
  createComponentDeploymentRequests: createComponentDeploymentRequests,
};
